import { analyticsRepository } from "@/repositories/analytics";
import { useStore } from "@/stores/useStore";
import { useCallback } from "react";

const AutomationBuilderEventNames = {
  exportUsed: "automation_export_used",
  importCompleted: "automation_import_completed",
  promptCopied: "automation_prompt_copied",
} as const;

type AutomationBuilderEventNames =
  (typeof AutomationBuilderEventNames)[keyof typeof AutomationBuilderEventNames];

export const useAutomationBuilderAnalytics = () => {
  const shopId = useStore((s) => s.shopId);

  const analyticsWrapper = useCallback(
    (
      eventName: AutomationBuilderEventNames,
      params?: Record<string, unknown>
    ) => {
      if (!shopId) {
        console.error(
          "Shop ID is missing, cannot log analytics event:",
          eventName
        );
        return;
      }
      analyticsRepository.logAnalyticsEvent(eventName, { ...params, shopId });
    },
    [shopId]
  );

  const logExportUsed = (scope: "all" | "single") => {
    analyticsWrapper(AutomationBuilderEventNames.exportUsed, { scope });
  };

  const logImportCompleted = (
    mode: "add" | "replaceAll",
    automationCount: number
  ) => {
    analyticsWrapper(AutomationBuilderEventNames.importCompleted, {
      mode,
      automationCount,
    });
  };

  const logPromptCopied = () => {
    analyticsWrapper(AutomationBuilderEventNames.promptCopied);
  };

  return { logExportUsed, logImportCompleted, logPromptCopied };
};
